import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "pb-2.5"
}
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "input-group-text flex items-center justify-center !bg-primary"
}
const _hoisted_8 = { class: "flex w-full relative" }
const _hoisted_9 = ["type", "placeholder", "disabled"]
const _hoisted_10 = {
  key: 0,
  class: "absolute w-full bg-slate-200 dark:bg-darkmode-400 top-10 z-60 flex flex-col items-start space-y-0.5"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "input-group-text flex items-center justify-center !bg-primary"
}
const _hoisted_13 = {
  key: 3,
  class: "input-group-text"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 2,
  class: "text-red-600 pt-1 text-left"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]

import Icon from "./Icon.vue"
import { watch, reactive, watchEffect, computed, onMounted, toRefs, inject, ref } from "vue";

interface Props {
  modelValue: any;
  label?: string;
  placeholder?: string;
  type?: string;
  helperText?: string;
  size?: string;
  rounded?: boolean;
  disabled?: boolean;
  state?: string;
  message?: string;
  tag?: string;
  pre?: string;
  post?: string;
  rule?: any;
  isClear?: boolean,
  icon?: {
    name: string;
    color: string;
    darkColor: string;
    front: boolean;
    back: boolean;
  };
  loading?: boolean;
  suggestions?: any[];
  previousValue?: any;
  previousLabel?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    modelValue: {},
    label: { default: "" },
    placeholder: {},
    type: { default: "text" },
    helperText: { default: "" },
    size: { default: "" },
    rounded: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    state: { default: "" },
    message: { default: "" },
    tag: { default: "" },
    pre: {},
    post: {},
    rule: {},
    isClear: { type: Boolean, default: true },
    icon: {},
    loading: { type: Boolean, default: false },
    suggestions: { default: ()=>[] },
    previousValue: { default: "" },
    previousLabel: { default: "" }
  },
  emits: ["update:modelValue", "event"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { modelValue,previousValue,previousLabel, suggestions,label, placeholder, type, helperText, size, rounded, disabled, state, message, tag, pre, post, rule } = toRefs(props);

const CLASS = {
  OUTLINE_NONE: 'outline outline-none',
  OUTLINE_SUCCESS: 'outline outline-none',
  OUTLINE_DANGER: 'outline outline-danger',
}

const _modelValue = computed({
  get() {
    return modelValue.value;
  },
  set(val) {
    emit("update:modelValue", val);
  },
});

const error = ref<boolean | string>("");

onMounted(() => {
  if (rule.value) {
    error.value = "";
  }
});

watch(
  () => _modelValue.value,
  (val, oldval) => {
    if (rule.value) {
      error.value = rule.value(val);
    }
  },
  { deep: true }
);

const isSuggestActive = ref<boolean>(false)

// const isShowAllSuggest =ref<boolean>(false)
const showAllSuggest = () =>{
  isSuggestActive.value = !isSuggestActive.value
  if(isSuggestActive.value){
      filterSuggest.value = suggestions.value
    }
}

const selectSuggest = (item : any) =>{
  _modelValue.value = item
  isSuggestActive.value = false
}

const filterSuggest =ref<any[]>([])

watch(
  () => _modelValue.value,
  (val, oldval) => {
    if(val){
      isSuggestActive.value = true
    }
    else{
      isSuggestActive.value = false
    }

    filterSuggest.value = suggestions?.value.filter((x:any)=> {
      let str = x.toString();
      let str_val = val.toString();
      if(str === str_val){
        isSuggestActive.value = false
      }
      return str.toLowerCase().includes(str_val.trim()?.toLowerCase())
    })

    if(!filterSuggest.value){
      filterSuggest.value = suggestions.value
    }
  },
  { deep: true }
);

const clear = () =>{
  _modelValue.value = ""
}
const event = () => {
  emit("event");
};
const _placeholder = computed(() => {
  return placeholder?.value === undefined ? label.value : placeholder.value;
});

const getLabelClasses = () => {
  return ["form-label flex", "mt-0", tag.value ? "flex flex-col w-full sm:flex-row" : ""];
};

const getTagClasses = () => {
  return ["sm:ml-auto px-2 pt-0.5 bg-slate-200 text-slate-600 dark:bg-darkmode-300 dark:text-slate-400 text-xs rounded-md"];
};

const getInputClasses = () => {
  return [
    "form-control",
    getSizeClass(size.value),
    rounded.value ? "form-control-rounded" : "",
    state.value ? `border-${getStateClass(state.value)}` : "",
    error.value === "" ? CLASS.OUTLINE_NONE : error.value !== true ? CLASS.OUTLINE_DANGER : CLASS.OUTLINE_SUCCESS,
  ];
};

const getMessageClasses = () => {
  return [state.value ? `mt-2 text-${getStateClass(state.value)}` : ""];
};

const getSizeClass = (size: string) => {
  switch (size) {
    case "sm":
      return "form-control-sm";
    case "lg":
      return "form-control-lg";
    default:
      return "";
  }
};

const getStateClass = (state: string) => {
  switch (state) {
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "error":
      return "danger";
    default:
      return "";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", null, [
    (_unref(label) || _unref(tag))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(getLabelClasses())
        }, [
          (_unref(label))
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(label)), 1))
            : _createCommentVNode("", true),
          (_unref(tag))
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(getTagClasses()),
                innerHTML: _unref(tag)
              }, null, 10, _hoisted_2))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(previousValue))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(previousLabel) ? `${_unref(previousLabel)}` : '') + " " + _toDisplayString(_unref(previousValue) ? ` : ${_unref(previousValue)}` : ''), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.$slots.pre || _unref(pre))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "pre"),
            (_unref(pre))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: _unref(pre)
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.icon && _ctx.icon?.front === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(Icon, {
              name: _ctx.icon?.name,
              size: "4",
              color: _ctx.icon?.color || 'white',
              darkColor: _ctx.icon?.darkColor || 'white'
            }, null, 8, ["name", "color", "darkColor"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: _unref(type),
          class: _normalizeClass(getInputClasses()),
          placeholder: _placeholder.value,
          disabled: _unref(disabled),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_modelValue).value = $event))
        }, null, 10, _hoisted_9), [
          [_vModelDynamic, _modelValue.value]
        ]),
        (_unref(suggestions)?.length > 0 && isSuggestActive.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterSuggest.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text-black dark:text-white w-full btn hover:bg-slate-400 dark:hover:bg-darkmode-200",
                  onClick: ($event: any) => (selectSuggest(item))
                }, _toDisplayString(item), 9, _hoisted_11))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        (_unref(suggestions)?.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "input-group-text flex items-center justify-center !bg-primary rounded-r cursor-pointer hover:!bg-primary/75",
              onClick: showAllSuggest
            }, [
              _createVNode(Icon, {
                name: !isSuggestActive.value ? 'ChevronUp' : 'ChevronDown',
                size: "4",
                color: 'white',
                darkColor: 'white'
              }, null, 8, ["name"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isClear && _modelValue.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "input-group-text flex items-center justify-center !bg-primary rounded-r cursor-pointer hover:!bg-primary/75",
              onClick: clear
            }, [
              _createVNode(Icon, {
                name: "X",
                size: "4",
                color: 'white',
                darkColor: 'white'
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.icon && _ctx.icon?.back === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  name: _ctx.icon?.name,
                  size: "4",
                  color: _ctx.icon?.color || 'white',
                  darkColor: _ctx.icon?.darkColor || 'white',
                  onClick: event
                }, null, 8, ["name", "color", "darkColor"]))
              : _renderSlot(_ctx.$slots, "loadingBar", { key: 1 })
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.post || _unref(post))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _renderSlot(_ctx.$slots, "post"),
            (_unref(post))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: _unref(post)
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (error.value !== true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (_unref(helperText))
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "form-help",
          innerHTML: _unref(helperText)
        }, null, 8, _hoisted_16))
      : _createCommentVNode("", true),
    (_unref(message))
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(getMessageClasses()),
          innerHTML: _unref(message)
        }, null, 10, _hoisted_17))
      : _createCommentVNode("", true)
  ]))
}
}

})